module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_1.25d2df1a5c5aedf024fabaaf85ced451.png";